// extracted by mini-css-extract-plugin
export default {"marker":"MapItext_marker__UMMUj"};